import type { Theme } from "@mui/material/styles";
import type { SystemStyleObject } from "@mui/system";
import { SIGNUP_COLORS } from "../../tokens";
import { styled } from "@mui/material/styles";
import { getBrandCustom } from "Util/getCustomColor";
import { colors } from "@zapalacorp/tokens";

export const CompanySlugContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "10px",
}));

export const CompanySlugSubdomain = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "1fr 20fr 1fr",
  gridColumnGap: "10px",
  alignItems: "center",
}));

export const CompanyInfoLabel = styled("span")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  color: getBrandCustom("darkPrimaryColor", colors.brandBlue600),
}));

export const CompanySlugInfo = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
}));

export const CompanySlugUrl = styled("span")(() => ({
  color: colors.gray500,
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: "24px",
}));

export const gridItem = {
  mb: "24px",
} as SystemStyleObject<Theme>;

export const firstRow = {
  mt: "24px",
} as SystemStyleObject<Theme>;

export const inputSx = {
  "& span": {
    "&[class*='makeStyles-label']": {
      color: `${SIGNUP_COLORS.primary} !important`,
      fontFamily: "Manrope !important",
      fontSize: "16px !important",
      fontWeight: "600 !important",
    },
  },
  "& .makeStyles-label-1, & .makeStyles-label-2, & .makeStyles-label-3, & .makeStyles-label-4, & .makeStyles-label-5, & .makeStyles-label-6, & .makeStyles-label-7, & .makeStyles-label-8, & .makeStyles-label-9, & .makeStyles-label-10": {
    color: `${SIGNUP_COLORS.primary} !important`,
  },
  "& .MuiFormControl-root span": {
    color: `${SIGNUP_COLORS.primary} !important`,
  },
};
